import React, { lazy, Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { customerTheme } from "../Admin/them/customeThem";
import RouteFallback from "../components/RouteFallback";
import { AuthModalProvider } from "../customer/Components/Auth/AuthModalContext";

// Eager — the browse-and-buy path. These are what a first-time visitor hits, so
// splitting them would only add a network round-trip before anything renders.
import Navigation from "../customer/Components/Navbar/Navigation";
import Footer from "../customer/Components/footer/Footer";
import Homepage from "../Pages/Homepage";
import Product from "../customer/Components/Product/Product/Product";
import ProductDetails from "../customer/Components/Product/ProductDetails/ProductDetails";
import Cart from "../customer/Components/Cart/Cart";
import { CartDrawerProvider } from "../customer/Components/Cart/CartDrawerContext";
import CartDrawer from "../customer/Components/Cart/CartDrawer";
import BackToTop from "../components/BackToTop";

// Lazy — account pages, checkout and the policy pages. Each is reached by a
// deliberate action, so a brief chunk fetch is unnoticeable, and none of them
// need to sit in the bundle every visitor downloads.
const Checkout = lazy(() => import("../customer/Components/Checkout/Checkout"));
const PaymentSuccess = lazy(() => import("../customer/Components/paymentSuccess/PaymentSuccess"));
const Order = lazy(() => import("../customer/Components/orders/Order"));
const OrderDetails = lazy(() => import("../customer/Components/orders/OrderDetails"));
const RateProduct = lazy(() => import("../customer/Components/ReviewProduct/RateProduct"));
const Profile = lazy(() => import("../customer/Components/Profile/Profile"));
const Wishlist = lazy(() => import("../customer/Components/Wishlist/Wishlist"));
const SearchResults = lazy(() => import("../customer/Components/Search/SearchResults"));
const ResetPassword = lazy(() => import("../Pages/ResetPassword"));
const About = lazy(() => import("../Pages/About"));
const Contact = lazy(() => import("../Pages/Contact"));
const PrivacyPolicy = lazy(() => import("../Pages/PrivacyPolicy"));
const TearmsCondition = lazy(() => import("../Pages/TearmsCondition"));
const PaymentsShipping = lazy(() => import("../Pages/PaymentsShipping"));
const ReturnsExchange = lazy(() => import("../Pages/ReturnsExchange"));
const PageNotFound = lazy(() => import("../Pages/PageNotFound"));

const CustomerRoutes = () => {
  const location = useLocation();

  // Only show Navigation component when not on the NotFound page
  const showNavigation = location.pathname !== "*";

  // const path=["/","/home","/about","/privacy-policy","/terms-condition","/contact","/men",`/product/${productId}`]
  return (
    <CartDrawerProvider>
    <AuthModalProvider>
    <div>
      <ThemeProvider theme={customerTheme}>
        {showNavigation && <Navigation />}
        <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Homepage />}></Route>
          <Route path="/home" element={<Homepage />}></Route>
          <Route path="/about" element={<About />}></Route>
          {/* Standard policy URLs (what Razorpay's onboarding form asks for).
              The older spellings below stay so existing links keep working. */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          <Route path="/terms-and-conditions" element={<TearmsCondition />}></Route>
          <Route path="/shipping-policy" element={<PaymentsShipping />}></Route>
          <Route path="/refund-policy" element={<ReturnsExchange />}></Route>
          <Route path="/cancellation-policy" element={<ReturnsExchange />}></Route>
          <Route path="/privaciy-policy" element={<PrivacyPolicy />}></Route>
          <Route path="/terms-condition" element={<TearmsCondition />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route
            path="/:lavelOne/:lavelTwo/:lavelThree"
            element={<Product />}
          ></Route>
          <Route
            path="/product/:productId/:category"
            element={<ProductDetails />}
          ></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/account/order" element={<Order />}></Route>
          <Route
            path="/account/order/:orderId/:itemId"
            element={<OrderDetails />}
          ></Route>
          <Route
            path="/account/rate/:productId"
            element={<RateProduct />}
          ></Route>
          <Route path="/checkout" element={<Checkout />}></Route>
          <Route path="/payment/:orderId" element={<PaymentSuccess />}></Route>
          <Route path="/account/profile" element={<Profile />}></Route>
          {/* New links use ?token=... ; the /:token form is kept so links from
              emails sent before that change still work until they expire. */}
          <Route path="/reset-password" element={<ResetPassword />}></Route>
          <Route path="/reset-password/:token" element={<ResetPassword />}></Route>
          <Route path="/payments-shipping" element={<PaymentsShipping />}></Route>
          <Route path="/returns-exchange" element={<ReturnsExchange />}></Route>
          <Route path="/search" element={<SearchResults />}></Route>
          <Route path="/wishlist" element={<Wishlist />}></Route>
          <Route path="*" element={<PageNotFound />}></Route>
        </Routes>
        </Suspense>
        <Footer />
        <BackToTop />
        <CartDrawer />
      </ThemeProvider>
    </div>
    </AuthModalProvider>
    </CartDrawerProvider>
  );
};

export default CustomerRoutes;
